import { usePage } from "@inertiajs/react";
import { BasketIcon } from "./icons";

// Placeholder mark until the real logo arrives. Drop the file into public/ and
// set `logo` in config/initializers/brand.rb to its path ("/logo.png") — this
// component picks it up from the shared `brand.logo` prop automatically.
export function Logo({ size = 40, className = "" }) {
  const { brand } = usePage().props;

  if (brand?.logo) {
    return (
      <img
        src={brand.logo}
        alt={brand.legal_name}
        width={size}
        height={size}
        className={`shrink-0 rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-brand-800 text-white ${className}`}
      style={{ width: size, height: size }}
    >
      <BasketIcon className="h-1/2 w-1/2" />
    </span>
  );
}

// Name + suffix, stacked or inline. Used in the sidebar and on the login card.
export function Wordmark({ className = "", nameClass = "", suffixClass = "" }) {
  const { brand } = usePage().props;

  return (
    <span className={`min-w-0 ${className}`}>
      <span className={`block truncate font-bold tracking-tight ${nameClass}`}>{brand?.name}</span>
      {brand?.suffix && (
        <span className={`block truncate ${suffixClass}`}>{brand.suffix}</span>
      )}
    </span>
  );
}

export function useBrand() {
  return usePage().props.brand ?? {};
}
